import React from "react";
import PropTypes from "prop-types";

const Category = (props) => {
  const label = (
    <h5 className="text-mega blog-article-category">{props.category}</h5>
  );
  if (props.categoryLink) {
    return <a href={props.categoryLink}>{label}</a>;
  }
  return label;
};

Category.propTypes = {
  category: PropTypes.string.isRequired,
  categoryLink: PropTypes.string,
};

export default Category;
